export class GetManyOperatingHourRecordsByDeviceIdRequest{
    deviceId : string | null = null;
}